import CollapseClose from "@/components/collapse";
import CollapseCloseList from "@/components/collapse/list3";
import CollapseCloseList4 from "@/components/collapse/list4";

import React from "react";

import { questions } from "@/utils/constants/faq.constants";
import en from "@/localization/en.json";
import Question9 from "@/components/collapse/question9";
import Question10 from "@/components/collapse/question10";
import MetaData from "@/components/seo/MetaData";
import { faqSchema } from "@/utils/constants/faq.constants";

function FAQ() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/faq`;

  return (
    <>
      <MetaData url={pageUrl} schema={faqSchema} />
      <div>
        <div className="h-[10rem] bg-[#E9F2EE] flex items-center justify-center">
          <h1 className="text-heading2 md:text-display2 text-center font-semibold w-[11.5rem] md:w-auto">
            {en["faq.faq"]}
          </h1>
        </div>

        <div className="mt-[3.5rem] px-[1.25rem] md:w-[80%] md:mx-auto mb-[4.25rem] md:mb-[8rem]">
          {questions.map((question) => (
            <CollapseClose
              key={question.id}
              question={question.question}
              answer={question.answer}
            />
          ))}

          <CollapseCloseList />
          <CollapseCloseList4 />
          <Question9 />
          <Question10 />
        </div>

        {/* will be used in when faq api will be available
      <div className="mt-[3.5rem] mb-[4.25rem] md:mt-[6.125rem] md:mb-[8rem]">
        <Pagination />
      </div> */}
      </div>
    </>
  );
}

export default FAQ;
